import { AsyncPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { PageViewAndEditModeSwitchManager } from './page-view-and-edit-mode-switch-manager.class';

@Component({
  imports: [MatIcon, AsyncPipe, MatButton, TranslatePipe],
  selector: 'page-view-and-edit-mode-switch',
  styleUrl: './page-view-and-edit-mode-switch.component.scss',
  templateUrl: './page-view-and-edit-mode-switch.component.html',
})
export class PageViewAndEditModeSwitchComponent {
  public manager = input.required<PageViewAndEditModeSwitchManager>();
}
